import {BigDecimal} from '@dms/api/shared';

export type PurchaseCashPaymentRequestBody = {
  paymentDiscriminator: PurchaseCashPaymentRequestBody.paymentDiscriminator;
  paymentMethod: PurchaseCashPaymentRequestBody.paymentMethod;
  dueDate: string;
  cashRegisterId: string;
  amount: BigDecimal;
  exchangeRate: string | null;
  supplierInvoiceNumber: string | null;
  dateOfTaxableSupply: string | null;
};

export namespace PurchaseCashPaymentRequestBody {
  export enum paymentDiscriminator {
    PURCHASE = 'PURCHASE',
  }

  export enum paymentMethod {
    CASH = 'CASH',
  }
}
